<template>
    <div class="home">
        <Gallery :categories="store.Galery"></Gallery>
    </div>
</template>

<script>
    import store from "@/store";
    import Gallery from "@/components/Gallery.vue";
    export default {
        name: 'Galer',
        data: function () {
            return {
                store: store
            };
        },
        components: {
            Gallery
        }
    }
</script>
